<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportEmployees()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importEmployees($event)" />

	<div class="row my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="employees?.length >= 5" [value]="10">10</option>
						<option *ngIf="employees?.length >= 10" [value]="25">25</option>
						<option *ngIf="employees?.length >= 25" [value]="50">50</option>
						<option *ngIf="employees?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
		<div class="row my-2">
			<div class="col-2 ms-lg-auto">
				<div class="dropdown">
					<a
						class="btn btn-secondary dropdown-toggle"
						profile="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
					</a>
					<div
						class="dropdown-menu px-3 py-3"
						aria-labelledby="dropdownFilter"
						id="menuFilter"
					>
					<div class="row">
						<span class="theme-main-color form-label">Expertise(s)</span>
						<div class="row vw-30 ms-0">
							<div
								class="col-4 form-check"
								*ngFor="let expertise of listExpertise"
							>
								<input
									type="checkbox"
									name="{{ expertise.id }}"
									class="form-check-input"
									[value]="expertise"
									(change)="updateSelectedExpertise($event, expertise)"
								/>
								<label class="form-check-label text-dark">
									{{ expertise.name }}
								</label>
							</div>
						</div>
					</div>

					</div>
				</div>
			</div>

			<div class="col-lg-3 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom(s), prénom(s)"
						[(ngModel)]="searchedText"
					/>
				</div>
			</div>
		</div>

		<div *ngIf="!isMobile" class="row mt-4">
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('lastName')">
					Intervenant
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('type')">
					Type
					<span
						*ngIf="sortType === 'type' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'type' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan">
					Email
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan">
					Téléphone
				</span>
			</div>
			<div class="col-3">
				<span
					class="hand-cursor fw-bold limitLineSpan"
				>
					Expertise
				</span>
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let employee of employees
						| filterEmployeeByName: searchedText
						| filterEmployeeByExpertises: listSelectedExpertise
						| orderBy : sortType : sortOrder
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  }
				"
				class="row my-1 pt-3 py-2 pb-1 rounded rounded-3 bg-light"
			>
				<div class="col-lg-2 col-12">
					<span *ngIf="isMobile" class="fw-bold limitLineSpan">Intervenant : </span>
					{{ employee.lastName }} {{ employee.firstName }} 
				</div>
				<div
					class="col-lg-2"
				>
					<span *ngIf="isMobile" class="fw-bold limitLineSpan">Type : </span
					>{{ employeeTypeString[employee.statutInt] }}
				</div>
				<div
					class="col-lg-2 limitLineDiv"
				>
					<span *ngIf="isMobile" class="fw-bold limitLineSpan">Email : </span
					>{{ employee.email }}
				</div>
				<div
					class="col-lg-2"
				>
					<span *ngIf="isMobile" class="fw-bold limitLineSpan">Téléphone : </span
					>{{ employee.telephone }}
				</div>
				<div
					class="col-12 col-lg-3 d-flex p-lg-0"
				>
					<div class="flex-grow-1">
						<span *ngIf="isMobile" class="fw-bold limitLineSpan"> Expertise(s) : </span>
						<span
							*ngFor="let exp of employee.expertises; let ilast = last"
							class="me-1"
						>
							{{ exp && ' ' + exp.name }}{{ exp && (ilast ? '' : ',') }}
						</span>

						<span *ngIf="employee.expertises.length === 0" class="me-1">
							Sans
						</span>
					</div>
					<i	*ngIf="checkIfEmployeeExt(employee)"
						(click)="updateSessionUser(employee)"
						profile="button"
						class="fs-5 bi bi-box-arrow-up-right mb-1 me-2"
						aria-hidden="true"
					></i>
					<i
						[routerLink]="['/gestion/employees', employee.id]"
						profile="button"
						class="fs-4 bi bi-caret-right-fill mb-1 me-2"
						aria-hidden="true"
					></i>
				</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<pagination-controls
			class="d-flex justify-content-center"
			(pageChange)="currentPage = $event"
			previousLabel="Précédent"
			nextLabel="Suivant"
		>
		</pagination-controls>
		<div class="d-flex justify-content-center">
			<label class="form-label mt-2 mx-2">Elements par page</label>
			<div class="">
				<select
					[(ngModel)]="itemsPerPage"
					#ctrl="ngModel"
					(change)="currentPage = 1"
					[ngModelOptions]="{ standalone: true }"
					class="form-select"
				>
					<option [value]="5">5</option>
					<option *ngIf="employees?.length >= 5" [value]="10">10</option>
					<option *ngIf="employees?.length >= 10" [value]="25">25</option>
					<option *ngIf="employees?.length >= 25" [value]="50">50</option>
					<option *ngIf="employees?.length >= 50" [value]="100">100</option>
				</select>
			</div>
		</div>
	</div>
</div>
